<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.8333 3.64648H9.16658C7.32559 3.64648 5.83325 5.13904 5.83325 6.97982V16.3887H14.1666V6.97982C14.1666 5.13904 12.6743 3.64648 10.8333 3.64648Z"
            fill="#E4EBFF"
        />
        <path
            d="M13.611 3.61133H6.38878C3.93422 3.61133 1.94434 5.60122 1.94434 8.05577V14.1669C1.94434 15.3942 2.93922 16.3891 4.16656 16.3891H15.8332C17.0606 16.3891 18.0554 15.3942 18.0554 14.1669V8.05577C18.0554 5.60122 16.0656 3.61133 13.611 3.61133Z"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M18.0554 9.16602H1.94434"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.83325 16.3891V6.94466C5.83325 5.10366 7.32559 3.61133 9.16659 3.61133H9.99992"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.1667 16.3891V6.94466C14.1667 5.10366 12.6743 3.61133 10.8333 3.61133H10"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 9.16602V11.3882"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
